export default "DROP TABLE `chat_interactions_to_file_blobs`;--> statement-breakpoint\nDROP TABLE `file_blobs`;"